import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  lineNo: {
    name: "lineNo",
    label: "Line No",
    type: "number",
    // errorMsg: "",
    required: true,
    disabled: true,
  },
  poNumber: {
    name: "poNumber",
    label: "PO Number",
    type: "text",
    disabled: true,
    // errorMsg: "",
  },
  extPONumber: {
    name: "extPONumber",
    label: "Ext PO Number",
    type: "text",
    // errorMsg: "",
  },
  poLineNo: {
    name: "poLineNo",
    label: "Po Line No",
    type: "number",
    disabled: true,
  },
  asnLineNo: {
    name: "asnLineNo",
    label: "ASN Line No",
    type: "number",
    disabled: true,
  },
  skuCode: {
    name: "skuCode",
    label: "SKU Code",
    type: "text",
    errorMsg: "SKU code is required",
    required: true,
    disabled: true,
  },
  packType: {
    name: "packType",
    label: "Pack Type",
    type: "text",
    // errorMsg: "Pack type is required",
    // required: true,
    disabled: true,
  },
  vDONo: {
    name: "vDONo",
    label: "DO No",
    type: "text",
    errorMsg: "DO No is required.",
    required: true,
    size: 3,
    // onChange: ((e) => {
    //     console.log(e);
    //     setFieldValue("vDONo", e.target.value);
    // }),
  },
  vInvNo: {
    name: "vInvNo",
    label: "Invoice No",
    type: "text",
    errorMsg: "Invoice no is required",
    required: true,
    size: 3,
  },
  recvWh: {
    name: "recvWh",
    label: "Receiving Warehouse",
    type: "select",
    required: true,
    errorMsg: "Receiving warehouse is required.",
  },
  recvZone: {
    name: "recvZone",
    label: "Receiving Zone",
    type: "select",
    required: true,
    errorMsg: "Receiving zone is required.",
  },
  recvLocation: {
    name: "recvLocation",
    label: "Receiving Location",
    type: "select",
    required: true,
    errorMsg: "Receiving location is required.",
  },
  cartonID: {
    name: "cartonID",
    label: "Carton ID",
    type: "text",
  },
  oln: {
    name: "oln",
    label: "OLN",
    type: "text",
  },
  mln: {
    name: "mln",
    label: "MLN",
    type: "text",
  },
  customsLot: {
    name: "customsLot",
    label: "Customs Lot",
    type: "text",
  },
  manualLot: {
    name: "manualLot",
    label: "Manual Lot",
    type: "text",
  },
  manufacturingDate: {
    name: "manufacturingDate",
    label: "Manufacturing Date",
    type: "date",
  },
  expiryDate: {
    name: "expiryDate",
    label: "Expiry Date",
    type: "date",
    // default: 0
  },
  baseUOM: {
    name: "baseUOM",
    label: "Base UOM",
    type: "text",
  },
  qtyExpected: {
    name: "qtyExpected",
    label: "Quantity Expected",
    type: "number",
    disabled: true,
  },
  varianceQty: {
    name: "varianceQty",
    label: "Variance Quantity",
    type: "number",
    disabled: true,
  },
  qtyReceived: {
    name: "qtyReceived",
    label: "Quantity Received",
    type: "number",
    required: true,
  },
  uom: {
    name: "uom",
    label: "UOM",
    type: "select",
    required: true,
    errorMsg: "UOM is required",
  },
  quantity: {
    name: "quantity",
    label: "Quantity",
    type: "number",
    disabled: true,
  },
  currencyCode: {
    name: "currencyCode",
    label: "Currency Code",
    type: "text",
  },
  unitPrice: {
    name: "unitPrice",
    label: "Unit Price",
    type: "number",
  },
  remark: {
    name: "remark",
    label: "Remark",
    type: "text",
  },
  condition: {
    name: "condition",
    label: "Condition",
    type: "select",
  },
  expiryDateCtrl: {
    name: "expiryDateCtrl",
    label: "Expiry Date Control",
    type: "switch",
  },
  mlnCtrl: {
    name: "mlnCtrl",
    label: "Manufacturing Lot No Control",
    type: "switch",
  },
  manDateCtrl: { name: "manDateCtrl", label: "Manufacturing Date Control", type: "switch" },
  manualLotCtrl: { name: "manualLotCtrl", label: "Manual Lot No Control", type: "switch" },
  inbSerialNbrCtrl: { name: "inbSerialNbrCtrl", label: "Inbound Serial No Control", type: "switch" },
  serialNumbers: { name: "serialNumbers", label: "Serial Numbers", type: "multi-select", xs: 12 },
};

const {
  status,
  lineNo,
  poNumber,
  extPONumber,
  poLineNo,
  asnLineNo,
  skuCode,
  packType,
  vDONo,
  vInvNo,
  recvWh,
  recvZone,
  recvLocation,
  cartonID,
  oln,
  mln,
  customsLot,
  manualLot,
  manufacturingDate,
  expiryDate,
  qtyExpected,
  varianceQty,
  qtyReceived,
  uom,
  quantity,
  currencyCode,
  unitPrice,
  remark,
  condition,
  expiryDateCtrl,
  manDateCtrl,
  manualLotCtrl,
  mlnCtrl,
  inbSerialNbrCtrl,
  serialNumbers
} = formField;

export const detailRender = [
  [lineNo, poNumber, extPONumber, status],
  [poLineNo, asnLineNo, vDONo, vInvNo],
  [skuCode, packType, unitPrice, currencyCode],
  [oln, recvWh, recvZone, recvLocation],
  [mln, cartonID, manufacturingDate, expiryDate],
  [qtyExpected, varianceQty, manualLot, customsLot],
  [qtyReceived, quantity, uom,condition],
  [remark],
  [serialNumbers],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  //---------------- detail ---------------
  [poLineNo.name]: Yup.number().typeError("Please enter number only"),
  // [asnLineNo.name]: Yup.number().typeError("Please enter number only"),
  [skuCode.name]: Yup.string().nullable().max(50).required(skuCode.errorMsg),
  [expiryDateCtrl.name]: Yup.boolean(),
  [manDateCtrl.name]: Yup.boolean(),
  [manualLotCtrl.name]: Yup.boolean(),
  [inbSerialNbrCtrl.name]: Yup.boolean(),
  [mlnCtrl.name]: Yup.boolean(),
  [packType.name]: Yup.string().nullable().max(10).required(packType.errorMsg),
  [vDONo.name]: Yup.string().nullable().max(20).required(vDONo.errorMsg),
  [vInvNo.name]: Yup.string().nullable().max(20).required(vInvNo.errorMsg),
  [recvWh.name]: Yup.string().nullable().max(20).required(recvWh.errorMsg),
  [recvZone.name]: Yup.string().nullable().max(20).required(recvZone.errorMsg),
  [recvLocation.name]: Yup.string().nullable().max(20).required(recvLocation.errorMsg),
  [cartonID.name]: Yup.string().nullable().max(20),
  [oln.name]: Yup.string().nullable().max(20),
  [mln.name]: Yup.string().nullable().max(20).when("mlnCtrl",{
    is:true,
    then:schema=>schema.required()
  }),
  [customsLot.name]: Yup.string().nullable().max(20),
  [manualLot.name]: Yup.string()
    .nullable()
    .max(20)
    .when("manualLotCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
    [manufacturingDate.name]: Yup.string()
    .nullable()
    .when("manDateCtrl", {
      is: true,
      then: (schema) => schema.required(),
    }),
  [expiryDate.name]: Yup.string().nullable().when("expiryDateCtrl",{
    is:true,
    then:schema=>schema.required()
  }),
  [customsLot.name]: Yup.string().nullable().max(20),
  [qtyExpected.name]: Yup.number().min(1).typeError("Please enter number only"),
  [qtyReceived.name]: Yup.number().min(1).typeError("Please enter number only"),
  [uom.name]: Yup.object()
    .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
    .nullable()
    .required(uom.errorMsg),
  [quantity.name]: Yup.number().min(1).typeError("Please enter number only"),
  // [baseUOM.name]: Yup.string().nullable().max(10),
  [currencyCode.name]: Yup.string().nullable().max(10),
  [unitPrice.name]: Yup.string().nullable().max(20),
    [serialNumbers.name]: Yup.array()
      .of(
        Yup.object().shape({
          serialNumber: Yup.string()
            .required("Serial Number is required")
            .max(50, "Serial Number cannot be longer than 50 characters"),
        })
      )
      .when("inbSerialNbrCtrl", {
        is: true,
        then: (schema) => schema.required().min(1, "At least one serial number is required"),
      }),
});
